import React, { useState, useEffect } from 'react'
import { Container, QuoteWrapper, QuoteText, QuoteAuthor } from './styles'
import { quotes } from './utils'

const QuoteDisplay: React.FC = () => {
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentQuoteIndex(prev => (prev + 1) % quotes.length)
    }, 7000)

    return () => clearInterval(timer)
  }, [])

  const { text, author } = quotes[currentQuoteIndex]

  return (
    <Container>
      <QuoteWrapper>
        <QuoteText>{text}</QuoteText>
        <QuoteAuthor>{author}</QuoteAuthor>
      </QuoteWrapper>
    </Container>
  )
}

export default QuoteDisplay
